import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPspManagement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H11C12.1046 21 13 20.1046 13 19V17H5C4.44772 17 4 16.5523 4 16V6C4 5.44772 4.44772 5 5 5H13C13 3.89543 12.1046 3 11 3H5ZM8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20ZM9 6C8.44772 6 8 6.44772 8 7V8H20V10H8V14C8 14.5523 8.44772 15 9 15H20C20.5523 15 21 14.5523 21 14V7C21 6.44772 20.5523 6 20 6H9ZM9 12C9 11.4477 9.44772 11 10 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H10C9.44772 13 9 12.5523 9 12Z",
		fill: "currentColor"
	})
});
export default SvgPspManagement;
